export const MAP_STAGES = {
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
  UPGRADE: 'upgrade',
  CHANGE_PLAN: 'changePlan',
  CONFIRM_CHANGE_PLAN: 'confirmChangePlan',
  THANK_YOU: 'thankYou',
  ERROR: 'error',
};
